import { useContext, useState } from "react";
import { useGeneric } from "../useGeneric";
import Loading from "../main/Loading";
import { objectOrJSONparse } from "../functions";
import prettyDate from "../tables/functions/prettyDate";
import prettyNumber from "../tables/functions/prettyNumber";
import AppContext from "../contexts/app-context";
import KsefInvoiceMapper from "./KsefInvoiceMapper";
import { InvoiceMetadataType } from "./InvoiceMetadataType";

export default function KsefPanel() {
  const [updates, setUpdates] = useState(0);
  const { invoices, loading }: any = useGeneric({
    name: "get-ksef-metadata",
    update: updates,
  });

  const { setModal2, modal2 }: any = useContext(AppContext);

  return (
    <div>
      {loading ? (
        <div style={{ padding: "10px" }}>
          <Loading text="Pobieranie danych z KSeF" variant={1}/>
        </div>
      ) : (
        <div>
          <div>Nowe faktury: {invoices?.length}</div>
          <div>
            <button
              onClick={() =>
                setModal2({
                  show: true,
                  type: <>Mapowanie faktur 1/{invoices?.length}</>,
                  content: (
                    <div>
                      <KsefInvoiceMapper invoiceMetaData={invoices?.at(0)} />
                    </div>
                  ),
                  width:"superwide"
                })
              }
            >
              Pobierz do systemu
            </button>
          </div>
          <div>
            {invoices && invoices?.length ? (
              <table className="dataTable">
                <thead>
                  <tr>
                    <th>Nr KSeF</th>
                    <th>Nr dok. źr.</th>
                    <th>Data wystawienia</th>
                    <th>Sprzedający</th>
                    <th>Kwota netto</th>
                    <th>Kwota brutto</th>
                    <th>Podatek VAT</th>
                    <th>Typ faktury</th>
                  </tr>
                </thead>
                <tbody>
                  {invoices?.map((i: InvoiceMetadataType) => (
                    <tr>
                      <td>{i?.ksefNumber}</td>
                      <td>{i?.invoiceNumber}</td>
                      <td>{prettyDate(i?.issueDate, undefined, true)}</td>
                      <td>
                        {i?.seller?.name} ({i?.seller?.nip})
                      </td>
                      <td>
                        {prettyNumber(i?.netAmount, { postfix: i?.currency })}
                      </td>
                      <td>
                        {prettyNumber(i?.grossAmount, { postfix: i?.currency })}
                      </td>
                      <td>{i?.vatAmount}</td>
                      <td>{i?.invoiceType}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <></>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

/*
[
{"ksefNumber":"2222222222-20260202-010000B5103C-1F",
"invoiceNumber":"C-345-2333",
"issueDate":"2026-02-02",
"invoicingDate":"2026-02-02T08:44:51.376243+00:00",
"acquisitionDate":"2026-02-02T08:44:51.602328+00:00",
"permanentStorageDate":"2026-02-02T08:44:57.12118+00:00",
"seller":{"nip":"2222222222","name":"Trylobit S.A."},
"buyer":{"identifier":{"type":"Nip","value":"2222322225"},"name":"Lila Lambada Tłumaczenie Skomplikowanych Kwestii"},
"netAmount":365.85,
"grossAmount":450,
"vatAmount":84.15,
"currency":"PLN",
"invoicingMode":"Online",
"invoiceType":"Vat",
"formCode":{"systemCode":"FA (3)","schemaVersion":"1-0E","value":"FA"},"isSelfInvoicing":false,"hasAttachment":false,"invoiceHash":"g5JiSDEY8jB2CcW195HZzn0XlgZULmu5iraKbtjRKs4="},{"ksefNumber":"2222222222-20260202-0200001C823C-33","invoiceNumber":"65","issueDate":"2026-02-02","invoicingDate":"2026-02-02T08:48:43.659398+00:00","acquisitionDate":"2026-02-02T08:48:43.759763+00:00","permanentStorageDate":"2026-02-02T08:48:46.71732+00:00","seller":{"nip":"2222222222","name":"Zwierzęta Domowe i Gospodarskie Sp. j."},"buyer":{"identifier":{"type":"Nip","value":"2222322225"},"name":"Tłumaczenie Zawiłych Kwestii"},"netAmount":4202,"grossAmount":4808.46,"vatAmount":606.46,"currency":"PLN","invoicingMode":"Online","invoiceType":"Vat","formCode":{"systemCode":"FA (3)","schemaVersion":"1-0E","value":"FA"},"isSelfInvoicing":false,"hasAttachment":false,"invoiceHash":"/WpGw4wx5lWrt6+xgRI+M7/9R/m/zFrk+JLJLjSNE98="},{"ksefNumber":"2222222222-20260203-0100E0A3634F-BF","invoiceNumber":"8","issueDate":"2026-02-03","invoicingDate":"2026-02-03T11:33:42.729958+00:00","acquisitionDate":"2026-02-03T11:33:42.926495+00:00","permanentStorageDate":"2026-02-03T11:33:47.527971+00:00","seller":{"nip":"2222222222","name":"cccc"},"buyer":{"identifier":{"type":"Nip","value":"2222322225"},"name":"vvvvvvv"},"netAmount":0,"grossAmount":0,"vatAmount":0,
"currency":"PLN",
"invoicingMode":"Online",
"invoiceType":"Kor",
"formCode":{"systemCode":"FA (3)","schemaVersion":"1-0E","value":"FA"},
"isSelfInvoicing":false,
"hasAttachment":false,
"invoiceHash":""]
*/
